import React, { useState } from "react";
import "./OfficeLocations.css";

export default function OfficeLocations({ currentLanguage = "en" }) {
    const isFrench = currentLanguage === "fr";

    // ================= ENGLISH DATA =================
    const dataEN = {
        subtitle: "OUR BRANCHES",
        title: "OFFICE LOCATIONS",
        email: "info@pestelandpartners.com",
        locations: [
            {
                id: 1,
                country: "Ouagadougou",
                subtitle: "Burkina Faso",
                flag: "/assets/images/contact/burkina.png",
                mapSrc:
                    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3859.2945145729513!2d-1.527187!3d12.3714279!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xe2ebcfc1a7fabcf%3A0xe4ee6e401e33ad43!2sOuagadougou%2C%20Burkina%20Faso!5e0!3m2!1sen!2sin!4v1705000000000!5m2!1sen!2sin",
                address: "Aux 1200 Logements, Avenue Jean-Baptiste Kiendrebeogo, Ouagadougou, Burkina Faso",
                phone: "+226 70192068",
                website: "#",
                officeImg: "/assets/images/contact/officeImg.png",
            },
            {
                id: 2,
                country: "Abidjan",
                subtitle: "Côte d'Ivoire",
                flag: "/assets/images/contact/abidjan.png",
                mapSrc:
                    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3979.539657040649!2d-4.0082562999999995!3d5.348960799999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xfc1ebb7cdd0f6ad%3A0xa81fedfb9e3bd9f0!2sAbidjan%2C%20C%C3%B4te%20d%27Ivoire!5e0!3m2!1sen!2sin!4v1705011111111!5m2!1sen!2sin",
               address: "Marcory Zone 4, Rue du Canal, Abidjan, Côte d’Ivoire",
                phone: "+225 07 06 635 052",
                website: "#",
                officeImg: "/assets/images/contact/officeImg.png",
            },
            // {
            //     id: 3,
            //     country: "Dubai",
            //     subtitle: "Dubai",
            //     flag: "/assets/images/contact/dubai.png",
            //     mapSrc:
            //         "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d115612.60966509231!2d55.1122965!3d25.2048493!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f4345487c583f%3A0xdeb16ca462bcdf71!2sDubai!5e0!3m2!1sen!2sin!4v1705000000002!5m2!1sen!2sin",
            //     address: "Dubai, UAE",
            //     phone: "+971 00 000 0000",
            //     website: "#",
            //     officeImg: "/assets/images/contact/officeImg.png",
            // },
            // {
            //     id: 4,
            //     country: "Mali",
            //     subtitle: "Mali",
            //     flag: "/assets/images/contact/mali.png",
            //     mapSrc:
            //         "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1004085.0193954534!2d-8.168432!3d17.570692!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xe51cd89dd5b39cb%3A0x3b0b390a5a505d29!2sMali!5e0!3m2!1sen!2sin!4v1705000000003!5m2!1sen!2sin",
            //     address: "Mali",
            //     phone: "+223 00 00 00 00",
            //     website: "#",
            //     officeImg: "/assets/images/contact/officeImg.png",
            // },
            // {
            //     id: 5,
            //     country: "Niger",
            //     subtitle: "Niger",
            //     flag: "/assets/images/contact/niger.png",
            //     mapSrc:
            //         "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1024371.1940247543!2d7.98396!3d17.607789!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xe6f879a12a2065b%3A0xa98a238f53ca720!2sNiger!5e0!3m2!1sen!2sin!4v1705000000004!5m2!1sen!2sin",
            //     address: "Niger",
            //     phone: "+227 00 00 00 00",
            //     website: "#",
            //     officeImg: "/assets/images/contact/officeImg.png",
            // },
            // {
            //     id: 6,
            //     country: "Guinea Conakry",
            //     subtitle: "Guinea Conakry",
            //     flag: "/assets/images/contact/guinea.png",
            //     mapSrc:
            //         "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1267857.670948346!2d-13.579324!3d9.641185!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xf04cd3b52596e2b%3A0x55c5e8f7ff7f6ba7!2sConakry%2C%20Guinea!5e0!3m2!1sen!2sin!4v1705000000005!5m2!1sen!2sin",
            //     address: "Guinea Conakry",
            //     phone: "+224 00 00 00 00",
            //     website: "#",
            //     officeImg: "/assets/images/contact/officeImg.png",
            // },
        ]
    };

    // ================= FRENCH DATA =================
    const dataFR = {
        subtitle: "NOS AGENCES",
        title: "EMPLACEMENTS DES BUREAUX",
        email: "info@pestelandpartners.com",
        locations: [
            {
                id: 1,
                country: "Ouagadougou",
                subtitle: "Burkina Faso",
                flag: "/assets/images/contact/burkina.png",
                mapSrc:
                    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3859.2945145729513!2d-1.527187!3d12.3714279!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xe2ebcfc1a7fabcf%3A0xe4ee6e401e33ad43!2sOuagadougou%2C%20Burkina%20Faso!5e0!3m2!1sen!2sin!4v1705000000000!5m2!1sen!2sin",
                address: "Ouagadougou, Burkina Faso : Aux 1200 logements, avenue Jean-Baptiste Kiendrebeogo",
                phone: "+226 70 19 20 68",
                website: "#",
                officeImg: "/assets/images/contact/officeImg.png",
            },
            {
                id: 2,
                country: "Abidjan",
                subtitle: "Côte d'Ivoire",
                flag: "/assets/images/contact/abidjan.png",
                mapSrc:
                    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3979.539657040649!2d-4.0082562999999995!3d5.348960799999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xfc1ebb7cdd0f6ad%3A0xa81fedfb9e3bd9f0!2sAbidjan%2C%20C%C3%B4te%20d%27Ivoire!5e0!3m2!1sen!2sin!4v1705011111111!5m2!1sen!2sin",
                address: "Marcory Zone 4, rue du Canal, Abidjan, Côte d’Ivoire",
                phone: "+225 07 06 635 052",
                website: "#",
                officeImg: "/assets/images/contact/officeImg.png",
            },
            // {
            //     id: 3,
            //     country: "Dubaï",
            //     subtitle: "Dubaï",
            //     flag: "/assets/images/contact/dubai.png",
            //     mapSrc:
            //         "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d115612.60966509231!2d55.1122965!3d25.2048493!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f4345487c583f%3A0xdeb16ca462bcdf71!2sDubai!5e0!3m2!1sen!2sin!4v1705000000002!5m2!1sen!2sin",
            //     address: "Dubaï, EAU",
            //     phone: "+971 00 000 0000",
            //     website: "#",
            //     officeImg: "/assets/images/contact/officeImg.png",
            // },
            // {
            //     id: 4,
            //     country: "Mali",
            //     subtitle: "Mali",
            //     flag: "/assets/images/contact/mali.png",
            //     mapSrc:
            //         "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1004085.0193954534!2d-8.168432!3d17.570692!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xe51cd89dd5b39cb%3A0x3b0b390a5a505d29!2sMali!5e0!3m2!1sen!2sin!4v1705000000003!5m2!1sen!2sin",
            //     address: "Mali",
            //     phone: "+223 00 00 00 00",
            //     website: "#",
            //     officeImg: "/assets/images/contact/officeImg.png",
            // },
            // {
            //     id: 5,
            //     country: "Niger",
            //     subtitle: "Niger",
            //     flag: "/assets/images/contact/niger.png",
            //     mapSrc:
            //         "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1024371.1940247543!2d7.98396!3d17.607789!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xe6f879a12a2065b%3A0xa98a238f53ca720!2sNiger!5e0!3m2!1sen!2sin!4v1705000000004!5m2!1sen!2sin",
            //     address: "Niger",
            //     phone: "+227 00 00 00 00",
            //     website: "#",
            //     officeImg: "/assets/images/contact/officeImg.png",
            // },
            // {
            //     id: 6,
            //     country: "Guinée Conakry",
            //     subtitle: "Guinée Conakry",
            //     flag: "/assets/images/contact/guinea.png",
            //     mapSrc:
            //         "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1267857.670948346!2d-13.579324!3d9.641185!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xf04cd3b52596e2b%3A0x55c5e8f7ff7f6ba7!2sConakry%2C%20Guinea!5e0!3m2!1sen!2sin!4v1705000000005!5m2!1sen!2sin",
            //     address: "Guinée Conakry",
            //     phone: "+224 00 00 00 00",
            //     website: "#",
            //     officeImg: "/assets/images/contact/officeImg.png",
            // },
        ]
    };

    // ================= SELECT LANGUAGE =================
    const data = isFrench ? dataFR : dataEN;
    const { subtitle, title, email, locations } = data;

    const [active, setActive] = useState(1);

    const activeLocation = locations.find((loc) => loc.id === active);

    return (
        <div className="office-container container">

            {/* Heading */}
            <h4 className="office-subtitle">
                <img src="/assets/images/contact/Frame1.png" alt="icon" /> {subtitle}
            </h4>
            <h2 className="office-title">{title}</h2>

            <div className="row mt-4 mob-responsive">

                {/* LEFT LIST */}
                <div className="col-lg-3">
                    {locations.map((loc) => (
                        <div
                            key={loc.id}
                            className={`office-item ${active === loc.id ? "active" : ""}`}
                            onClick={() => setActive(loc.id)}
                        >
                            <img src={loc.flag} alt={loc.country} className="office-flag" />
                            <div>
                                <h5>{loc.country}</h5>
                                <p>{loc.subtitle}</p>
                            </div>
                        </div>
                    ))}
                </div>

                {/* RIGHT MAP */}
                <div className="col-lg-9">

                    <div className="map-wrapper">
                        {/* Floating card */}
                        <div className="map-info-card">
                            <img
                                src={activeLocation.officeImg}
                                className="map-info-img"
                                alt="office"
                            />

                            <div className="map-info-text">
                                <p className="map-info-row">
                                    <img src="/assets/images/contact/map-pin.png" width={14} alt="location" />{" "}
                                    {activeLocation.address}
                                </p>

                                <p className="map-info-row">
                                    <img src="/assets/images/contact/phone-dark.png" width={14} alt="phone" />{" "}
                                    {activeLocation.phone}
                                </p>

                                <p className="map-info-row">
                                    <img src="/assets/images/contact/web.png" width={14} alt="email" />{" "}
                                    <a href={`mailto:${email}`}>{email}</a>
                                </p>
                            </div>
                        </div>

                        {/* Google Map */}
                        <iframe
                            src={activeLocation.mapSrc}
                            className="map-frame"
                            loading="lazy"
                            allowFullScreen
                            title={`Map of ${activeLocation.country}`}
                        ></iframe>
                    </div>

                </div>
            </div>
        </div>
    );
}